export default {
  en: {
    snack: {
      copied_success: 'Copied',
    },
    actions: {
      edit: 'Edit',
      restore: 'Restore',
      delete: 'Delete',
      copy: 'Copy text',
      visit_profile: 'Go to user profile',
      info: 'Info',
      reply: 'Reply',
    },
  },
};
